import { singUpMutations } from "./signup/index";
import { countryCodeMutations } from "./countryCodes";
import { authMutations } from "./auth";
import { businessTypeMutations } from "./businessType";
import { trainingGroupMutations } from "./trainingGroup";
import { shopcardMutations } from "./shopCard";
import { templateMutations } from "./template";
import { memberMutations } from "./member";
import { userCamDigitMutations } from "./confirmAccount";
export default {
  changLanguage(state) {
    state.lan = state.lan == "kh" ? "en" : "kh";
  },
  ...singUpMutations,
  ...countryCodeMutations,
  ...authMutations,
  ...businessTypeMutations,
  ...trainingGroupMutations,
  ...shopcardMutations,
  ...templateMutations,
  ...memberMutations,
  ...userCamDigitMutations
};
